import { Table, Typography } from 'antd';
import { useMemo } from 'react';
import { block1config } from '../Block1';
import { FormBlockTypes } from './DocumentPreviewSubjectData';
import { PreviewNestedData } from './PreviewNestedData';

export type DocumentPreviewBlockData = {
  data: FormBlockTypes;
};

export const DocumentPreviewBlock1 = ({ data }: DocumentPreviewBlockData) => {
  const tableData = useMemo(() => {
    const changedTableData = {
      key: 'block1Data',
      block1Data: {},
    };
    if (data) {
      changedTableData.block1Data = (
        <PreviewNestedData fieldsData={data} fieldsConfig={block1config} />
      );
    }
    return changedTableData;
  }, [data]);

  return (
    <div>
      <Typography.Title level={5}>
        Ugdomosios medžiagos pritaikymas
      </Typography.Title>
      <Table
        pagination={false}
        columns={[
          {
            key: 'block1Data',
            title: 'Pritaikymo būdai',
            dataIndex: 'block1Data',
          },
        ]}
        dataSource={[tableData]}
        size="small"
      />
    </div>
  );
};
